import { defineComponent as _defineComponent } from 'vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'IconTitle',
  props: {
    icon: { type: Object, required: true },
    title: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();




const __returned__ = { get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})